import { render, staticRenderFns } from "./SvgSprite.vue?vue&type=template&id=47045b29&scoped=true&"
import script from "./SvgSprite.vue?vue&type=script&lang=js&"
export * from "./SvgSprite.vue?vue&type=script&lang=js&"
import style0 from "./SvgSprite.vue?vue&type=style&index=0&id=47045b29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47045b29",
  null
  
)

export default component.exports